<template>
  <p class="details">
    <strong>Note: This user does not have full access</strong>
    to the Survey Insights tab. In order to grant them access to view Survey Insights,
    visit the
    <a
      href="/app/settings/team/demographic-permissions"
      target="_blank"
      rel="noopener noreferrer"
      class="text-brandPrimary font-weight-bold"
    >My Team</a> page.
  </p>
</template>

<style scoped lang="less">
.details {
  font-size: 12px;
  line-height: 150%;
  font-weight: 500;

  a {
    text-decoration: underline;
  }
}
</style>
